/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicareGgScores } from './MedicareGgScores';
import {
    MedicareGgScoresFromJSON,
    MedicareGgScoresFromJSONTyped,
    MedicareGgScoresToJSON,
    MedicareGgScoresToJSONTyped,
} from './MedicareGgScores';
import type { MedicareSlpAssessmentForm } from './MedicareSlpAssessmentForm';
import {
    MedicareSlpAssessmentFormFromJSON,
    MedicareSlpAssessmentFormFromJSONTyped,
    MedicareSlpAssessmentFormToJSON,
    MedicareSlpAssessmentFormToJSONTyped,
} from './MedicareSlpAssessmentForm';
import type { CognitiveLevelAssessmentForm } from './CognitiveLevelAssessmentForm';
import {
    CognitiveLevelAssessmentFormFromJSON,
    CognitiveLevelAssessmentFormFromJSONTyped,
    CognitiveLevelAssessmentFormToJSON,
    CognitiveLevelAssessmentFormToJSONTyped,
} from './CognitiveLevelAssessmentForm';
import type { NursingAssessmentForm } from './NursingAssessmentForm';
import {
    NursingAssessmentFormFromJSON,
    NursingAssessmentFormFromJSONTyped,
    NursingAssessmentFormToJSON,
    NursingAssessmentFormToJSONTyped,
} from './NursingAssessmentForm';
import type { AssessmentFormConditionsServices } from './AssessmentFormConditionsServices';
import {
    AssessmentFormConditionsServicesFromJSON,
    AssessmentFormConditionsServicesFromJSONTyped,
    AssessmentFormConditionsServicesToJSON,
    AssessmentFormConditionsServicesToJSONTyped,
} from './AssessmentFormConditionsServices';
import type { AssessmentFormDiagnosis } from './AssessmentFormDiagnosis';
import {
    AssessmentFormDiagnosisFromJSON,
    AssessmentFormDiagnosisFromJSONTyped,
    AssessmentFormDiagnosisToJSON,
    AssessmentFormDiagnosisToJSONTyped,
} from './AssessmentFormDiagnosis';

/**
 * 
 * @export
 * @interface MedicareAssessmentForm
 */
export interface MedicareAssessmentForm {
    /**
     * 
     */
    diagnosis?: AssessmentFormDiagnosis;
    /**
     * 
     */
    gg_scores?: MedicareGgScores;
    /**
     * 
     */
    slp_assessment?: MedicareSlpAssessmentForm;
    /**
     * 
     */
    cognitive_level_assessment?: CognitiveLevelAssessmentForm;
    /**
     * 
     */
    conditions_services?: AssessmentFormConditionsServices;
    /**
     * 
     */
    nursing_assessment?: NursingAssessmentForm;
}

/**
 * Check if a given object implements the MedicareAssessmentForm interface.
 */
export function instanceOfMedicareAssessmentForm(value: object): value is MedicareAssessmentForm {
    return true;
}

export function MedicareAssessmentFormFromJSON(json: any): MedicareAssessmentForm {
    return MedicareAssessmentFormFromJSONTyped(json, false);
}

export function MedicareAssessmentFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicareAssessmentForm {
    if (json == null) {
        return json;
    }
    return {
        
        'diagnosis': json['diagnosis'] == null ? undefined : AssessmentFormDiagnosisFromJSON(json['diagnosis']),
        'gg_scores': json['gg_scores'] == null ? undefined : MedicareGgScoresFromJSON(json['gg_scores']),
        'slp_assessment': json['slp_assessment'] == null ? undefined : MedicareSlpAssessmentFormFromJSON(json['slp_assessment']),
        'cognitive_level_assessment': json['cognitive_level_assessment'] == null ? undefined : CognitiveLevelAssessmentFormFromJSON(json['cognitive_level_assessment']),
        'conditions_services': json['conditions_services'] == null ? undefined : AssessmentFormConditionsServicesFromJSON(json['conditions_services']),
        'nursing_assessment': json['nursing_assessment'] == null ? undefined : NursingAssessmentFormFromJSON(json['nursing_assessment']),
    };
}

export function MedicareAssessmentFormToJSON(json: any): MedicareAssessmentForm {
    return MedicareAssessmentFormToJSONTyped(json, false);
}

export function MedicareAssessmentFormToJSONTyped(value?: MedicareAssessmentForm | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diagnosis': AssessmentFormDiagnosisToJSON(value['diagnosis']),
        'gg_scores': MedicareGgScoresToJSON(value['gg_scores']),
        'slp_assessment': MedicareSlpAssessmentFormToJSON(value['slp_assessment']),
        'cognitive_level_assessment': CognitiveLevelAssessmentFormToJSON(value['cognitive_level_assessment']),
        'conditions_services': AssessmentFormConditionsServicesToJSON(value['conditions_services']),
        'nursing_assessment': NursingAssessmentFormToJSON(value['nursing_assessment']),
    };
}

